import { Typography } from '@arionbanki/arionui';
import { InfoIcon } from 'components';
import { classNames as cn } from 'helpers';
import type { QuestionProps } from 'types';
import { Caption, Description } from './Labels';
import { QuestionContent } from './QuestionContent';
import { useQuestion } from './useQuestion';

export function Question(props: QuestionProps) {
	const ctx = useQuestion(props);
	if (!ctx.isVisible) return null;

	const { depended, framed, iconTitle, isSubquestion } = ctx;
	const pcn = cn('text-secondary', { bold: !isSubquestion, 'mt-4': !isSubquestion });
	const wcn = cn({ question: !depended, depended, 'col-6': isSubquestion, framed });
	const questionContent = <QuestionContent {...props} />;
	const caption = <Caption {...props} />;

	return (
		<div className={wcn}>
			{framed ? (
				<div className="row">
					<div className="col-12">
						<Typography className={pcn} TagName="p">
							{caption}
							{iconTitle && <InfoIcon title={iconTitle} />}
						</Typography>
					</div>
					<div className="col-12">{questionContent}</div>
				</div>
			) : (
				<>
					{!ctx.isDropdown && (
						<>
							<Typography className={pcn} TagName="p">
								{caption}
							</Typography>
							<Description {...props} />
						</>
					)}
					{questionContent}
				</>
			)}
		</div>
	);
}
